import { Component, OnInit, ViewChild } from "@angular/core";
import { forkJoin } from "rxjs";
import { NavService } from "../../_services/_nav.service";
import { Table } from "primeng/table";
import { Politica } from "../../_models/politica";
import { PoliticaService } from "../../_services/politica.service";
import {AutenticacionService} from '../../_services/autenticacion.service';
import {Funcionalidad} from '../../_models/funcionalidad';

@Component({
  selector: "app-politicas",
  templateUrl: "./politicas.component.html",
  styleUrls: ["./politicas.component.css"],
})
export class PoliticasComponent implements OnInit {
  politicas: Politica[] = [];
  columnas: any[];
  busqueda: string;
  carPoliticas = true;
  esDetalle = false;
  politicaSeleccionada: Politica;
  @ViewChild('dt') tabla: Table;
  seccion = 'L';
  menu: Funcionalidad = new Funcionalidad();

  constructor(
    private navServicio: NavService,
    private politicaService: PoliticaService,
    private autServicio: AutenticacionService
  ) {}

  ngOnInit() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/politicas' );
    if ( mn ) {
      this.menu = mn;
    }
    this.busqueda = this.navServicio.getSearch("politicas");
    this.setearColumnas();
    this.cargaInicial();
  }

  cargaInicial() {
    this.carPoliticas = true;
    this.politicas = [];
    forkJoin(this.politicaService.listadoPoliticas()).subscribe(
      ([politicas]) => {
        this.politicas = politicas;
        this.carPoliticas = false;
        this.tabla.filterGlobal(this.busqueda, "contains");
      }
    );
  }

  setearColumnas() {
    this.columnas = [
      {
        field: "codigo",
        header: this.navServicio.buscarMensaje("POLITICAS.LBL_CODIGO"),
        sort: false,
      },
      {
        field: "nombre",
        header: this.navServicio.buscarMensaje("POLITICAS.LBL_POLITICA"),
        sort: false,
      },
      {
        field: "categoriaPolitica",
        header: this.navServicio.buscarMensaje("POLITICAS.LBL_CATEGORIA"),
        sort: false,
      },
      {
        field: "indicadorReglaRetanqueo",
        header: this.navServicio.buscarMensaje("POLITICAS.LBL_RETANQUEO"),
        sort: true,
      },
      {
        field: "indicadorAlerta",
        header: this.navServicio.buscarMensaje("POLITICAS.LBL_ALERTA"),
        sort: true,
      },
      {
        field: "indicadorDescarta",
        header: this.navServicio.buscarMensaje("POLITICAS.LBL_DESCARTA"),
        sort: true,
      },
      {
        field: "indicadorHabilitado",
        header: this.navServicio.buscarMensaje("LBL_HABILITADO"),
        sort: true,
      },
      {
        field: "det",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
  }

  setBusqueda() {
    this.navServicio.setSearch("politicas", this.busqueda);
  }

  crearPolitica() {
    this.esDetalle = false;
    this.politicaSeleccionada = null;
    this.seccion = "F";
  }

  ver(politica: Politica) {
    this.esDetalle = true;
    this.politicaSeleccionada = politica;
    this.seccion = "F";
  }

  editar(politica: Politica) {
    this.esDetalle = false;
    this.politicaSeleccionada = politica;
    this.seccion = "F";
  }

  regresarListado() {
    this.seccion = "L";
    this.cargaInicial();
  }
}
